import { render } from "./school-setting.vue?vue&type=template&id=0dcd3d13&scoped=true&ts=true"
import script from "./school-setting.vue?vue&type=script&lang=ts"
export * from "./school-setting.vue?vue&type=script&lang=ts"

import "./school-setting.vue?vue&type=style&index=0&id=0dcd3d13&scoped=true&lang=css"

import exportComponent from "E:\\项目对接\\parent-reporting-backend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dcd3d13"]])

export default __exports__